import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const AnnouncedChristmasIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_announcedchristmasillustration_svg_a)"
      d="m77.741 138.343 25.318-5.039L59.953 112l-25.318 5.039z"
      opacity={0.5}
    />
    <path fill="#FDDE84" d="m103.059 65.68 75.576-13.348-43.106-21.304L59.953 44.64z" />
    <path fill="#C39000" d="M103.059 65.68v67.536l-43.106-21.304v-67.27z" />
    <path fill="#FCCE09" d="M103.059 65.68v67.536l75.576-13.525v-67.36z" />
    <path fill="#980000" d="m82.73 123.227-6.495-3.183-.376-67.624 6.965 3.447z" />
    <path fill="#D2002E" d="m152.941 39.602-77.176 12.73 6.964 3.447 76.989-12.818z" />
    <path fill="#AF0527" d="m140.047 126.674 7.906-1.414.47-67.624-8.376 1.414z" />
    <path fill="#D2002E" d="m104.941 36.508 43.483 21.216-8.377 1.414-42.73-21.215z" />
    <path
      fill="#D2002E"
      d="M116.047 46.055S100.329 45.083 96 44.906c-4.33-.265-6.118 1.945-6.118 4.243 0 2.122 2.07 3.801 4.047 4.773 2.071 1.15 10.918 6.63 10.918 6.63l17.224-10.696z"
    />
    <path
      fill="#AF0527"
      d="M122.165 49.591s-7.906 1.415-11.953 2.387c-4.047.707-7.906 1.68-7.059 5.923.753 4.243 5.835 2.652 8.659.707 2.259-2.298 10.353-9.017 10.353-9.017"
    />
    <path
      fill="#D2002E"
      d="M118.118 45.79s4.517-11.226 5.553-13.79c1.035-2.652 3.011-5.48 5.835-4.243 2.823 1.15 15.247 7.425 15.247 7.425l-21.082 14.056z"
    />
    <path
      fill="#AF0527"
      d="M123.388 49.149s11.953-10.52 13.647-11.934c1.789-1.414 7.624-4.508 7.906-.972s-2.823 4.773-6.306 6.63c-3.576 1.768-15.247 6.276-15.247 6.276M98.07 46.055l18.542.707 2.07 2.387-12.894 2.652 9.412-2.829-6.118-.265 4.8-.972zM120.094 45.083l5.082-11.227-3.294 9.989 2.259-2.652-1.035 2.829s3.576-4.243 3.576-4.067l-2.541 4.774 9.883-7.602-10.918 9.547z"
    />
    <path
      fill="#D2002E"
      d="M123.671 45.525c2.07.972 2.07 2.829 0 3.801-2.071.972-5.083.972-7.059 0-2.071-.972-2.071-2.829 0-3.801 1.976-1.15 5.27-1.15 7.059 0"
    />
    <path
      fill="#AF0527"
      d="M124.141 48.619c-2.07.972-5.082.972-7.059 0-1.223-.708-1.788-1.68-1.223-2.652-1.035.972-.753 2.386.753 3.359 2.07.972 5.082.972 7.059 0 .753-.265 1.035-.707 1.223-1.15.094.266-.188.266-.753.443"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_announcedchristmasillustration_svg_a"
        x1={65.715}
        x2={72.526}
        y1={131.091}
        y2={116.514}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
